(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.configs', []);

	angular
		.module('expo-cupom-digital.constants', []);

	angular
		.module('expo-cupom-digital.directives', []);

	angular
		.module('expo-cupom-digital.services', []);

	angular
		.module('expo-cupom-digital.routes', []);


	angular
		.module('expo-cupom-digital.interceptors', []);
}());